import { PayloadAction } from "store/types"
import { UserAction } from "./actions"
import { User } from "./types"

export type UserState = {
    user: User | null
    pending: boolean
    error: string | null
}
/** ATTRIBUTES */
const initialState = {
    user: null,
    pending: false,
    error: null,
} as UserState

export const userReducer = (
    state = initialState,
    action: PayloadAction<UserAction>
) => {
    switch (action.type) {
        case UserAction.SET_USER: {
            return {
                ...state,
                user: action.payload,
                error: null,
            }
        }
        case UserAction.SET_PENDING: {
            return {
                ...state,
                pending: action.payload,
            }
        }
        case UserAction.SET_ERROR: {
            return {
                ...state,
                error: action.payload,
            }
        }
        case UserAction.CLEAR_USER: {
            return {
                user: null,
                error: null,
                pending: false,
            }
        }
        default:
            return state
    }
}
